/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {StateService} from '@uirouter/core';

export function enrichCreativeRows(items: any[], stateService: StateService): void {
  _.forEach(items, (creative: any) => {
    creative.previewUrl = stateService.href('nude.preview', {
      creativeId: creative.id,
      networkId: creative.network.id,
      creativeWidth: creative.width,
      creativeHeight: creative.height,
      lineItemId: creative.lineItemId,
      lineItemCode: creative.lineItemCode
    }, {absolute: true});
  });
}

export function configureCreativeList(list: any, LocalNetworkProfile: any): void {
  list.hasObjectSource = LocalNetworkProfile.hasObjectSource();
  list.creativeFields = ['name', {param: 'Layout', label: 'layout'}, {param: '', label: 'parent'}, {label: 'URLs', param: ''}, {label: 'impressionTrackingUrls', param: ''}, {label: 'dimensions', param: 'width'}, {param: '', label: 'info'}, {param: '', label: 'preview'}, 'updateTime', {param: '', label: 'targeting'}];
  if (list.hasObjectSource) {
    list.creativeFields.splice(3, 0, 'source');
  }

  const skipForDefaults = ['source', 'impressionTrackingUrls', 'targeting'];
  list.defaultFields = _.filter(list.creativeFields, (field: any) => {
    return skipForDefaults.indexOf(field.label || field.param || field) < 0;
  });
  list.sel = {};
}

export function postFillGenerateFormatFees(ctrl: any): {validItems: any[]; creativeFormatFees: any[]} {
  const validItems = _.filter(ctrl.items, (item: any) => {
    return !_.find(item.validationWarnings, (vw: any) => {
      return vw.preventsAdServing;
    });
  });

  const creativeFormatFees = _.map(_.filter(validItems, (item: any) => {
    return _.get(item.creativeFormatFee, ['monetary', 'amount']) > 0 || (_.get(item.creativeFormatFee, ['multiCurrencyMonetaryAmounts', 'length']) > 0 && _.find(_.get(item.creativeFormatFee, ['multiCurrencyMonetaryAmounts']), (fee: any) => {
      return fee.amount > 0;
    }));
  }), (item: any) => {
    return item.creativeFormatFee;
  });

  return {validItems: validItems, creativeFormatFees: creativeFormatFees};
}
